<template>
  <div class="agent-chat-button-container">
    <IconButton
      @click="store.togglePanel()"
      variant="ghost"
      icon="sparkle"
      size="large"
      shape="round"
      class="agent-chat-button"
      aria-label="Open Tallo AI assistant"
    />
  </div>
</template>

<script setup lang="ts">
import { IconButton } from '@tallo/design-system';

import { useAgentChatStore } from '../stores/agent-chat.store';

const store = useAgentChatStore();
</script>

<style scoped lang="scss">
// Mirrors the actions-needed bell next door: same IconButton recipe, same white-circle override.
.agent-chat-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-chat-button {
  background-color: #fff;
  border-radius: 50%;
  color: var(--t-color-neutral-600);

  &:hover:not(:disabled) {
    border-color: var(--t-color-orange-500);
    background-color: #fff;
  }
}
</style>
